//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, useStatic, useContext, useRoute, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  setup() {
    const {$content} = useContext()
    const route = useRoute()

    const page = useStatic(id => {
      return $content('veranstaltung', id).fetch()
    }, computed(() => route.value.params.id), 'veranstaltung')

  
    const showAnmeldung = computed(() => {
      // Anmeldung ist vorhanden
      if (page.value.anmeldung) {
        const anmeldung = page.value.anmeldung
        if (anmeldung.visible != undefined) {
          return anmeldung.visible
        }
        return true
      }
      return false
    })

    return {
      page,
      showAnmeldung
    }
  },
  head() {
    return {
      title: this.page.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.description,
        },
        // Open Graph
        {
          hid: 'og:title',
          property: 'og:title',
          content:
            this.page.title +
            ` (${this.page.begin.split('T')[0]
              .split('-')
              .reverse()
              .join('.')} - ${this.page.ende.split('T')[0].split('-').reverse().join('.')})`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.page.description,
        },
        // Twitter Card
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content:
            this.page.title +
            ` (${this.page.begin.split('T')[0]
              .split('-')
              .reverse()
              .join('.')} - ${this.page.ende.split('T')[0].split('-').reverse().join('.')})`,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.page.description,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.page.featuredImage,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.page.featuredImage,
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.ec-nordbund.de/veranstaltungen/' + this.page.slug,
          hid: 'canonical',
        },
      ],
    }
  },
})
